"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    appendElement: ()=>appendElement,
    appendLinkTag: ()=>appendLinkTag,
    appendScriptTag: ()=>appendScriptTag,
    appendStyleTag: ()=>appendStyleTag,
    createElement: ()=>createElement,
    createLinkTag: ()=>createLinkTag,
    createMetaTag: ()=>createMetaTag,
    createScriptTag: ()=>createScriptTag,
    createStyleTag: ()=>createStyleTag
});
function createLinkTag(href, rel = 'stylesheet', type, media) {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (type) link.type = type;
    if (media) link.media = media;
    return link;
}
function createScriptTag(src, content, type = "text/javascript", async, defer) {
    const script = document.createElement("script");
    script.type = type;
    if (src) script.src = src;
    if (content) script.textContent = content;
    if (async) script.async = true;
    if (defer) script.defer = true;
    return script;
}
function createStyleTag(content) {
    const style = document.createElement('style');
    style.textContent = content;
    return style;
}
function createMetaTag(name, content, httpEquiv) {
    const meta = document.createElement('meta');
    if (name) meta.name = name;
    if (content) meta.content = content;
    if (httpEquiv) meta.httpEquiv = httpEquiv;
    return meta;
}
function createElement(tagName, attributes) {
    const element = document.createElement(tagName);
    if (attributes) Object.entries(attributes).forEach(([key, value])=>{
        element.setAttribute(key, value);
    });
    return element;
}
function appendElement(element, parent = document.body, position = 'beforeend') {
    if ('beforeend' === position) parent.appendChild(element);
    else parent.insertAdjacentElement(position, element);
    return element;
}
function appendLinkTag(href, parent = document.head, rel = 'stylesheet', type, media) {
    const link = createLinkTag(href, rel, type, media);
    return appendElement(link, parent);
}
function appendScriptTag(src, parent = document.body, content, type = "text/javascript", async, defer) {
    const script = createScriptTag(src, content, type, async, defer);
    return appendElement(script, parent);
}
function appendStyleTag(content, parent = document.head) {
    const style = createStyleTag(content);
    return appendElement(style, parent);
}
exports.appendElement = __webpack_exports__.appendElement;
exports.appendLinkTag = __webpack_exports__.appendLinkTag;
exports.appendScriptTag = __webpack_exports__.appendScriptTag;
exports.appendStyleTag = __webpack_exports__.appendStyleTag;
exports.createElement = __webpack_exports__.createElement;
exports.createLinkTag = __webpack_exports__.createLinkTag;
exports.createMetaTag = __webpack_exports__.createMetaTag;
exports.createScriptTag = __webpack_exports__.createScriptTag;
exports.createStyleTag = __webpack_exports__.createStyleTag;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "appendElement",
    "appendLinkTag",
    "appendScriptTag",
    "appendStyleTag",
    "createElement",
    "createLinkTag",
    "createMetaTag",
    "createScriptTag",
    "createStyleTag"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
